<template>
  <div class="content">
    <l-table
      ref="table"
      :tableConfig="tableConfig"
      @tableChange="tableChange"
      :searchParams="searchTime"
      :emptyText="$t('experiment.exercise.noData')"
      :emptyImgSrc="emptyImgSrc"
    >
      <template slot="searchConditions">
        <a-form layout="inline" class="l-form">
          <a-form-item label="" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            <a-range-picker
              v-model="dateRange"
              format="YYYY-MM-DD"
              :placeholder="[$t('experiment.exercise.startTime'), $t('experiment.exercise.endTime')]"
              @change="onChange"
            />
          </a-form-item>
        </a-form>
      </template>
      <template slot="searchActions"> </template>
      <template #operates="{ record }">
        <div class="operates">
          <a-button type="link" style="padding: 0" @click="viewDetails(record.id)">
            {{ $t('experiment.exercise.viewDetails') }}
          </a-button>
        </div>
      </template>
      <template #filterDropdown="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }">
        <div
          style="padding: 8px"
        >
          <a-cascader
            v-ant-ref="c => (majorInfoRef = c)"
            v-model="selectedMajor"
            allowClear
            :options="majorInfo"
            :placeholder="$t('experiment.exercise.selectMajor')"
            :fieldNames="{ label: 'name', value: 'id', children: 'child' }"
            @change="selectedMajorOk"
          />
        </div>
      </template>
      <a-icon
        slot="filterIcon"
        slot-scope="filtered"
        type="filter"
        theme="filled"
        :style="{ color: !filtered ? '#FFA000' : undefined }"
      />
      <template #serchTip>
        <p>{{ $t('experiment.exercise.tryAnotherTime') }}</p>
      </template>
      <template #statusName="{ record }">
        <span :style="{ color: record.status === '1' ? '#F06321' : '#2DB58B' }">{{ record.statusName }}</span>
      </template>
      <template #timeUsed="{ record }">
        <span>{{ record.timeUsed }}s</span>
      </template>
    </l-table>
    <Details :visible="visible" :data="stuSteps" @close="visible = false" />
  </div>
</template>

<script>
import jsCookie from 'js-cookie'
import LTable from '@/components/LTable/index.vue'
import Details from './modal/details.vue'
import { classMap, experimentList, majorList, exerciseDetails, stuExerciseDetails } from '@/api/experiment'

const userType = JSON.parse(jsCookie.get('user_type')).join(',')
export default {
  components: {
    LTable,
    Details
  },
  data() {
    return {
      table: null,
      keyword: undefined,
      majorInfoRef: null,
      tableConfig: {
        tableName: '',
        tableColumns: [
          {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            align: 'center',
            width: 60
          },
          {
            title: this.$t('experiment.exercise.table.experimentName'),
            dataIndex: 'experimentName',
            key: 'experimentName',
            align: 'center',
            filterIcon: filtered => this.$createElement('filter-icon', { props: { checked: filtered } }),
            filters: []
          },
          {
            title: this.$t('experiment.exercise.table.name'),
            dataIndex: 'operator',
            key: 'operator',
            align: 'center',
          },
          {
            title: this.$t('experiment.exercise.table.major'),
            dataIndex: 'majorName',
            key: 'majorName',
            align: 'center',
            filterIcon: filtered => this.$createElement('filter-icon', { props: { checked: filtered } }),
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              customRender: 'customRender'
            }
          },
          {
            title: this.$t('experiment.exercise.table.class'),
            dataIndex: 'className',
            key: 'className',
            align: 'center',
            filterIcon: filtered => this.$createElement('filter-icon', { props: { checked: filtered } }),
            filters: []
          },
          {
            title: this.$t('experiment.exercise.table.score'),
            dataIndex: 'score',
            key: 'score',
            align: 'center',
            sorter: (a, b) => a.score - b.score
          },
          {
            title: this.$t('experiment.exercise.table.startTime'),
            dataIndex: 'startTime',
            key: 'startTime',
            align: 'center'
          },
          {
            title: this.$t('experiment.exercise.table.endTime'),
            dataIndex: 'endTime',
            key: 'endTime',
            align: 'center'
          },
          {
            title: this.$t('experiment.exercise.table.duration'),
            dataIndex: 'timeUsed',
            key: 'timeUsed',
            align: 'center',
            scopedSlots: { customRender: 'timeUsed' }
          },
          {
            title: this.$t('experiment.exercise.table.status'),
            dataIndex: 'statusName',
            key: 'statusName',
            align: 'center',
            width: 120,
            filterIcon: filtered => this.$createElement('filter-icon', { props: { checked: filtered } }),
            filters: [
              { text: this.$t('experiment.exercise.status.completed'), value: '1' },
              { text: this.$t('experiment.exercise.status.incomplete'), value: '2' }
            ],
            scopedSlots: { customRender: 'statusName' }
          },
          {
            title: this.$t('experiment.exercise.table.operations'),
            dataIndex: 'operates',
            key: 'operates',
            align: 'center',
            width: 120,
            customSlots: true,
            scopedSlots: { customRender: 'operates' }
          }
        ],
        tablePort: {
          list: userType.includes('student') ? '/student/experiment/practice/list' : '/experiment/practice/list'
        }
      },
      formItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 }
      },
      visible: false,
      majorInfo: [],
      selectedMajor: [],
      majorIds: '',
      dateRange: null,
      searchTime: {
        startTime: '',
        endTime: ''
      },
      stuSteps: [],
      userType,
      emptyImgSrc: require('@/assets/img/pic_zw@2x.png')
    }
  },
  watch: {
    dateRange(val) {
      if (val.length === 2) {
        this.searchTime.startTime = val[0].format('YYYY-MM-DD')
        this.searchTime.endTime = val[1].format('YYYY-MM-DD')
      } else {
        this.searchTime.startTime = ''
        this.searchTime.endTime = ''
      }
    }
  },
  methods: {
    search() {},
    onChange() {
      this.searchTime.startTime = this.dateRange[0] ? this.dateRange[0].format('YYYY-MM-DD') : ''
      this.searchTime.endTime = this.dateRange[1] ? this.dateRange[1].format('YYYY-MM-DD') : ''
    },
    viewDetails(id = 4) {
      if (this.userType.includes('student')) {
        stuExerciseDetails({ id }).then(res => {
          this.stuSteps = res.data.steps
        })
      } else {
        exerciseDetails({ id }).then(res => {
          this.stuSteps = res.data.steps
        })
      }
      this.visible = true
    },
    tableChange([filters, getList, sort]) {
      const { className, experimentName, statusName } = filters
      const { order } = sort
      getList({
        condition: {
          experimentIds: (experimentName && experimentName) || [],
          classIds: (className && className) || [],
          scoreSort: (order && order === 'ascend' ? '2' : '1') || '',
          statuses: (statusName && statusName) || []
        }
      })
    },
    selectedMajorOk() {
      if (this.selectedMajor.length < 3) {
        this.$refs.table.getList({
          condition: {
            majorId: []
          }
        })
        // this.$message.warning('请选择专业')
        return
      }
      this.majorIds = this.selectedMajor[2]
      this.$refs.table.isDefaultQuery = false
      this.$refs.table.isDefaultSearch = false
      this.$refs.table.getList({
        condition: {
          majorId: [this.majorIds]
        }
      })
    },
    selectedMajorClear() {},
    init() {
      experimentList().then(res => {
        this.tableConfig.tableColumns[1].filters = res.data.list.map(item => ({
          text: item.name,
          value: item.id
        }))
      })
      classMap().then(res => {
        this.tableConfig.tableColumns[4].filters = res.data.list.map(item => ({
          text: item.name,
          value: item.id
        }))
      })
      majorList().then(res => {
        this.majorInfo = removeEmptyChild(res.data.list)
        console.log('this.majorInfo ----->', this.majorInfo)
        function removeEmptyChild(data) {
          if (Array.isArray(data)) {
            return data.map(item => removeEmptyChild(item))
          } else if (typeof data === 'object' && data !== null) {
            if (data.child && data.child.length === 0) {
              delete data.child
            } else {
              data.child = removeEmptyChild(data.child)
            }
            return data
          } else {
            return data
          }
        }
      })
      if (this.userType.includes('student')) {
        this.tableConfig.tableColumns.splice(2, 1)
        this.tableConfig.tableColumns.splice(3, 1)
      }
    },
    handleSearch(selectedKeys, confirm, dataIndex) {
      console.log('selectedKeys ----->', selectedKeys, confirm, dataIndex)
    },

    handleReset(clearFilters) {
      clearFilters()
      console.log('selectedKeys ----->', clearFilters)
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="less" scoped>
.content {
  padding: 0px 19px;
  /deep/ .ant-btn-link:focus {
    // color: #5B7499;
  }
}
</style>

<style lang="less">
.l-form {
  .ant-form-item {
    margin-bottom: 0 !important;
    width: 250px;
    line-height: 30px;
  }
  .ant-form-item-label {
    margin-top: 10px;
  }
}
.l_filter_footer {
  border-top: solid 1px #e8e8e8;
  margin-top: 15px;
  padding-top: 10px;
  padding-bottom: 5px;
  display: flex;
  justify-content: space-between;
  .ant-btn-link {
    color: #ff6d00;
    padding: 0;
    line-height: 1;
    height: auto;
  }
}
</style>
